import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../../../environments/environment';
import { objective } from '../../../models/Objective';
import { ProjectObjective } from '../../../models/project-vm';
import { MessageService } from '../../../services/message.service';
import { UnsavedChangesService } from '../../../../unsaved-changes.service';

@Component({
  selector: 'app-ginfo-objective-goals',
  templateUrl: './ginfo-objective-goals.component.html',
  styleUrl: './ginfo-objective-goals.component.css'
})
export class GinfoObjectiveGoalsComponent implements OnInit, OnChanges {
  @Output() objectivesChanged = new EventEmitter<ProjectObjective[]>();

  @Input() projectObjectives: ProjectObjective[] = [];
  @Input() disableAfterReview: boolean = false;
  @Input() disableAll: boolean = false;
  @Input() projectTitle: string = "Test";
  objectives: objective[] = [];

  constructor(private http: HttpClient, private msgService: MessageService
    ,private unsavedChangesService: UnsavedChangesService
  ) { }
  onAnyFieldValueChange(e:boolean){
    if(e){
      this.unsavedChangesService.setUnsavedChanges(true);
    }
  }

  ngOnInit() {
    // Fetch objectives from your API
    this.fetchObjectives();

  }
  ngOnChanges(changes: SimpleChanges): void {
    if (changes['projectObjectives'].currentValue != undefined && changes['projectObjectives'].currentValue != changes['projectObjectives'].previousValue) {
      if (this.projectObjectives.length == 0) {
        this.addObjectve();
      }
    }
  }

  fetchObjectives() {
    this.http.get<objective[]>(`${environment.gateway_url}/GetAllObjectives`).subscribe(
      (data: objective[]) => {
        this.objectives = data;
      },
      (error: any) => {
        console.error('Error fetching objectives:', error);
      }
    );
  }

  addObjectve(index = 0) {
    this.projectObjectives.splice(index, 0, new ProjectObjective(0));
  }

  removeObjective(index: number) {
    this.projectObjectives.splice(index, 1);
    this.objectivesChanged.emit(this.projectObjectives);
  }

  onSelectionChange(selectedId: number, index: number) {
    if (selectedId !== undefined) {
      this.objectivesChanged.emit(this.projectObjectives);
    }
  }

  exportObjectiveTxt() {
    const filteredObjectives = this.projectObjectives.filter(objective => objective.projectObjectiveID > 0);

    if (filteredObjectives.length === 0) {
      this.msgService.htmlError("No valid objectives to export");
      return;
    }

    // Function to get the objective name based on objectiveID
    const getObjectiveName = (id: number): string => {
      const objective = this.objectives.find(o => o.objectiveID === id);
      return objective ? objective.objective : 'Unknown';
    };


    const header = [
      'PROJECT OBJECTIVES'
    ];

    const rows = filteredObjectives.map(objective => [
      getObjectiveName(objective.objectiveID)
     
    ]);

    // Convert rows to CSV format
    const csvContent = [header, ...rows].map(row => row.join('\t')).join('\n');

    const blob = new Blob([csvContent], { type: 'text/plain;charset=utf-8' });

    const link = document.createElement('a');
    link.href = URL.createObjectURL(blob);
    link.download = `${this.projectTitle}_ProjectObjectives.txt`;
    link.click();
  }

}
